import React, { useCallback } from 'react';
import removeDoubleSlashes from '../utils/removeDoubleSlashes';

export const useFallbackImage = (
  image?: string | any[],
  fallbackImage = 'fallback-wine.png',
) => {
  const deps =
    typeof image === 'undefined'
      ? [fallbackImage]
      : Array.isArray(image)
      ? [...image, fallbackImage]
      : [image, fallbackImage];

  return useCallback((ev: React.SyntheticEvent<HTMLImageElement, Event>) => {
    const baseUrl = (globalThis as any)['BASE_URL'];
    if (baseUrl) {
      (ev.target! as HTMLImageElement).src = removeDoubleSlashes(
        `${baseUrl}/assets/${fallbackImage}`,
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
};
